const USER_SERVICE_BASE =
  process.env.REACT_APP_USER_SERVICE_URL ||
  process.env.USER_SERVICE_URL ||
  'https://identity.wassiniluxury.com/api';

const TOKEN_KEY = 'wassiniToken';

const buildIdentityUrl = (path) => {
  if (!path.startsWith('/')) {
    return `${USER_SERVICE_BASE}/${path}`;
  }
  return `${USER_SERVICE_BASE}${path}`;
};

// Identity only lets a logged-in user read their own account
const authHeaders = () => {
  if (typeof window === 'undefined') return {};
  const token = window.localStorage.getItem(TOKEN_KEY);
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const handleResponse = async (response) => {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message =
      payload?.message ||
      payload?.error ||
      response.statusText ||
      'Request failed';
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }
  return payload;
};

export const userExists = async (phone) => {
  const url = buildIdentityUrl(
    `/user/exists?phoneNumber=${encodeURIComponent(phone)}`
  );
  const response = await fetch(url);
  return handleResponse(response);
};

// Sends a verification code to the phone number by WhatsApp
export const sendOtp = async (phone) => {
  const url = buildIdentityUrl(
    `/sendOtpToUser?phoneNumber=${encodeURIComponent(phone)}`
  );
  const response = await fetch(url, { method: 'POST' });
  return handleResponse(response);
};

// Exchanges the code for { access_token, refresh_token, role, user }
export const otpLogin = async (phone, otp) => {
  const url = buildIdentityUrl(
    `/otp/login?phoneNumber=${encodeURIComponent(phone)}&otp=${encodeURIComponent(otp)}`
  );
  const response = await fetch(url, { method: 'POST' });
  return handleResponse(response);
};

export const getUserByPhoneNumber = async (phone) => {
  const url = buildIdentityUrl(
    `/user/phoneNumber?phoneNumber=${encodeURIComponent(phone)}`
  );
  const response = await fetch(url, { headers: authHeaders() });
  return handleResponse(response);
};

export const getUserById = async (id) => {
  const url = buildIdentityUrl(`/user/${encodeURIComponent(id)}`);
  const response = await fetch(url, { headers: authHeaders() });
  return handleResponse(response);
};

export const createIdentityUser = async (payload) => {
  const url = buildIdentityUrl('/user/save');
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  return handleResponse(response);
};

export default {
  userExists,
  sendOtp,
  otpLogin,
  getUserByPhoneNumber,
  getUserById,
  createIdentityUser,
};
